import React from 'react'
import { Provider } from 'react-redux'

import IdFinder from '../id_finder'
import ProductDetail from '../components/product_detail'
import Themed from 'store/v2/react/components/Themed'

const store = window.booqableStore

export default class Detail extends React.Component {
  static displayName = 'ProductDetailContainer'

  render () {
    return (
      <Provider store={store}>
        <Themed>
          <div className="booqable-component booqable-component-product-detail" style={{ display: 'none' }}>
            <IdFinder {...Object.assign({}, this.props)} hideOnLoad>
              <ProductDetail />
            </IdFinder>
          </div>
        </Themed>
      </Provider>
    )
  }
}
